import * as actions from './actions'
import { saveEntities } from '../factories'
import { sequences as route } from '../route'
import { showFeedback } from '../feedback/factories'
import { set } from 'cerebral/factories'
import { props } from 'cerebral'
import { loadProfilesSequence } from '../profiles/factories'
import { compose, path, pluck } from 'ramda'

const loadProfiles = loadProfilesSequence(compose(pluck('profile'), path(['props', 'entities', 'questCompletions'])), 'profileIds')

export const find = [
  //
  actions.find,
  saveEntities(),
]

export const findForList = [
  //
  set(props`useRouteParams`, true),
  actions.find,
  actions.setList,
  loadProfiles,
  saveEntities(),
]

export const get = [
  //
  actions.get,
  loadProfiles,
  saveEntities(),
]

export const save = [
  //
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: 'Completed quest saved', type: 'success' }),
  route.toQuestCompletions,
]
